const white = {
  hover: '#FAF9FC',
  active: '#F7F5FA',
  primary: '#FFFFFF',
};

const black = {
  primary: '#333333',
};

const blue = {
  hover: '#445E74',
  light: '#C9E1FF',
  active: '#3C5367',
  border: '#E6EDF6',
  primary: '#506E89',
  shadow10: '#7B91BF19',
  shadow16: '#7B91BF29',
  shadow20: '#7B91BF33',
  accent: { active: '#C8DCF7' },
  secondary: { hover: '#C5D3D9', active: '#A3B4B8', primary: '#D6DFE3' },
};

const gray = {
  hover: '#E5E7EB',
  primary: '#E5EAF0',
  neutral: '#9DA5B0',
  divider: '#D1DFEE',
  dark: {
    active: '#858C94',
    primary: '#9DA5B0',
  },
};

const red = {
  hover: '#E55653',
  active: '#D14A47',
  primary: '#FD6460',
  secondary: { hover: '#FADDDD', active: '#F1C9C8', primary: '#FFEFEF' },
};

const green = {
  primary: '#44BB6E',
  secondary: { primary: '#E2F1E7' },
};

const surface = {
  dark: '#F1F3F6',
  light: '#FCFCFD',
};

const teal = {
  primary: '#518181',
};

const mauve = {
  light: '#F5EDEE',
  primary: '#AC9B9C',
};

export const colors = {
  red,
  blue,
  gray,
  teal,
  white,
  black,
  green,
  mauve,
  surface,
};
